export const INPUT_QUERY = 'section > section > input, section > section > textarea';
export const INPUT_IDENTIFIER = 'input';
